export default {
  form: {
    padding: 10,
  },
  // row: {
  //   display: 'flex',
  //   flex: 1,
  //   flexDirection: 'row',
  // },
  configureJobContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
};



// WEBPACK FOOTER //
// ./src/components/Jobs/CreateJobDialog/styles.js